import { heroStats } from '@/mocks/homeData';

export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden bg-background-950"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Artistic%20warm%20manga%20library%20interior%20with%20ambient%20golden%20lighting%2C%20abstract%20comic%20panel%20textures%20in%20gentle%20orange%20amber%20and%20cream%20tones%20floating%20organically%2C%20clean%20minimalist%20composition%20with%20depth%2C%20warm%20atmospheric%20gradient%20from%20dark%20to%20light%2C%20subtle%20Japanese%20ink%20wash%20influence%20in%20the%20corners%2C%20calm%20sophisticated%20reading%20sanctuary%20atmosphere%2C%20high%20quality%20aesthetic%20background%20design%2C%20editorial%20photography%20style&width=1600&height=900&seq=gugu-hero-bg&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55" />

      <div className="relative w-full z-10 px-4 md:px-6 py-16 md:py-24">
        <div className="mx-auto max-w-[1440px] flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-sm font-medium mb-6 border border-primary-500/25">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-400" />
              日漫 · 韩漫 · 国漫 全品类覆盖
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-3">
              古古漫画网
              <br />
              <span className="text-primary-300">免费全集下拉式漫画阅读平台</span>
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-medium mb-4">
              海量全集合集，一拉到底畅快阅读
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              古古漫画网收录超过两万部日漫、韩漫、国漫作品，独创下拉式阅读技术，无需翻页即可连续畅读。每日同步更新三百余话热门连载，覆盖热血、恋爱、奇幻、悬疑等数十种类型。无论你是资深老漫迷还是刚刚入坑的新读者，古古漫画网都是你的专属漫画图书馆。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              {heroStats.map((stat, i) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-300">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/50 leading-tight">
                    {stat.label}
                  </div>
                  {i < heroStats.length - 1 && (
                    <div className="hidden sm:block w-px h-8 bg-white/15 mx-2" />
                  )}
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
              >
                <i className="ri-fire-line text-lg" />
                立即开始阅读
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); handleScroll('#features'); }}
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-white/12 text-white font-medium text-sm hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm border border-white/10"
              >
                了解更多特色
                <i className="ri-arrow-down-line text-lg" />
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative">
              <div className="relative w-[260px] h-[370px] md:w-[340px] md:h-[470px] rounded-xl overflow-hidden shadow-2xl shadow-black/40">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20manga%20webtoon%20scrolling%20interface%2C%20vertical%20reading%20mode%20with%20vibrant%20comic%20panels%20in%20warm%20orange%20coral%20and%20amber%20tones%2C%20Japanese%20Korean%20Chinese%20comic%20art%20fusion%2C%20clean%20modern%20phone%20device%2C%20soft%20ambient%20screen%20glow%2C%20cozy%20immersive%20reading%20atmosphere%2C%20high%20quality%20digital%20product%20mockup%2C%20minimalist%20composition%20with%20focus%20on%20screen%20content&width=720&height=960&seq=gugu-hero-visual&orientation=portrait"
                  alt="古古漫画网手机端下拉式阅读界面展示"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent p-4">
                  <p className="text-white text-sm font-semibold">下拉式阅读 · 一滑到底</p>
                  <p className="text-white/60 text-xs mt-0.5">极致流畅的漫画阅读体验</p>
                </div>
              </div>

              <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 w-16 h-16 md:w-20 md:h-20 rounded-xl bg-accent-500 flex items-center justify-center shadow-lg shadow-accent-500/30">
                <div className="text-center">
                  <span className="block text-white text-lg md:text-xl font-heading font-bold leading-tight">高清</span>
                  <span className="block text-white/80 text-[10px] md:text-xs leading-tight">画质</span>
                </div>
              </div>

              <div className="absolute -bottom-3 -left-3 md:-bottom-4 md:-left-4 px-3 py-2 rounded-lg bg-background-50 shadow-lg border border-background-200/60">
                <div className="flex items-center gap-1.5">
                  <div className="w-2 h-2 rounded-full bg-green-500" />
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">每日 300+ 话更新中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}